import { useSelector } from 'react-redux';
import { type AppState } from '~/store/app.store';

const modalIsOpenSelector = (state: AppState) => !!state.modal.stack.length;
export const useModalIsOpenSelector = () => useSelector(modalIsOpenSelector);

const modalStackSelector = (state: AppState) => state.modal.stack;
export const useModalStackSelector = () => useSelector(modalStackSelector);
